export enum OperatorRole {
    Supervisor = "Supervisor",
    Operator = "Operator"
}